import { render, staticRenderFns } from "./LoadingCenter.vue?vue&type=template&id=fd62fcf8&scoped=true&"
import script from "./LoadingCenter.vue?vue&type=script&lang=js&"
export * from "./LoadingCenter.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCenter.vue?vue&type=style&index=0&id=fd62fcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd62fcf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
